import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("input", {
    type: "text",
    id: _ctx.componentId + 'input',
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.actualizarValor()))
  }, null, 40, ["id"]))
}